export const contactIcon = function (resourceType) {
    switch (resourceType) {
        case 'Group':
            return ['far', 'people-group'];
        case 'Location':
            return ['far', 'map-marker-alt'];
        case 'Room':
            return ['far', 'door-closed'];
        // Staff. An ID badge rather than user-md: on the muted, outlined avatar the stethoscope read as a bikini top.
        case 'User':
            return ['far', 'id-badge'];
        case 'Organization':
            return ['far', 'university'];
        case 'Patient':
            return ['far', 'heartbeat'];
        // Professionals (outside providers, case managers and the like): a person at a building, so they no longer share the
        // plain person with Individuals and differ by more than colour.
        case 'Practitioner':
            return ['far', 'building-user'];
        case 'Person':
        default:
            return ['far', 'user'];
    }
};

export const contactColor = function (resourceType) {
    switch (resourceType) {
        case 'Location':
        case 'Room':
            return 'related';
        case 'Organization':
            return 'organization';
        case 'Patient':
            return 'patient';
        case 'Person':
            return 'related';
        case 'Practitioner':
            return 'practitioner';
        case 'User':
            return 'user';
        default:
            return 'primary';
    }
};
